<template>
  <div class="statistics-line">
    <div class="statistics-line__title">
      <span>통계 도표</span>
    </div>
    <div class="statistics-line__chart">
      <div class="option-wrap">
        <span
          v-for="option in options"
          :key="option.value"
          :class="option.value === target ? 'active' : ''"
          @click="() => onFilterChart(option.value)"
        >
          {{ option.label }}
        </span>
      </div>

      <ve-line
        :data="chartData"
        :settings="{
          axisSite: { right: ['click'] },
          yAxisName: ['조회수', '클릭수'],
        }"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "StatisticsLineChart",
  data: () => ({
    target: "total",
    stats: {},
    options: [
      { label: "전체", value: "total" },
      { label: "띠형배너", value: "0" },
      { label: "팝업배너", value: "1" },
      { label: "이벤트", value: "2" },
      { label: "푸시알림", value: "3" },
    ],
  }),
  props: {
    chartData: Object,
    statistic: Object,
  },
  watch: {
    statistic(nVal) {
      if (nVal) {
        nVal.campaign_item_stat.forEach((outerElement) => {
          outerElement.forEach((element) => {
            this.stats[element.date] = {};
            this.stats[element.date]["view"] = {};
            this.stats[element.date]["click"] = {};
          });
        });

        nVal.campaign_item_stat.forEach((outerElement) => {
          outerElement.forEach((element) => {
            if (element.hasOwnProperty("type")) {
              this.stats[element.date]["view"][element.type] =
                element.item_view;
              this.stats[element.date]["click"][element.type] =
                element.item_click;
            } else {
              this.stats[element.date]["view"]["total"] = element.item_view;
              this.stats[element.date]["click"]["total"] = element.item_click;
            }
          });
        });

        this.setChart();
      }
    },
  },
  methods: {
    onFilterChart(value) {
      this.target = value;
      this.setChart();
    },

    setChart() {
      this.chartData.columns = ["date", "view", "click"];
      this.chartData.rows = [];

      for (let date in this.stats) {
        this.chartData.rows.push({
          date: date,
          view: this.stats[date]["view"][this.target],
          click: this.stats[date]["click"][this.target],
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "~styles/color";
@import "~styles/size";

.statistics-line {
  margin-top: 40px;
  padding: 24px;
  white-space: nowrap;

  &__title {
    text-align: center;
    font-size: 15px;
    color: #595959;
  }

  &__chart {
    margin-top: 24px;
  }
}

.option-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 14px;

  span {
    font-size: 13px;
    cursor: pointer;
    color: #797979;

    &.active {
      color: #2f60ff;
      font-weight: 500;
    }
  }

  span + span {
    margin-left: 20px;
  }
}

@media (max-width: $min_layout) {
  .statistics-line {
    padding: 24px 16px;

    &__chart {
      flex-direction: column;

      &-type {
        padding-top: 16px;
      }
    }
  }
}
</style>
